// extracted by mini-css-extract-plugin
export var activityContainer = "_kb-0";
export var typingIndicatorContainer = "_kb-1";
export var typingIndicatorDot = "_kb-2";
export var wave = "_kb-3";